import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  title?: string;
  titleRight?: React.ReactNode;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  padding = 'md',
  title,
  titleRight,
  onClick
}: CardProps) {
  const paddings: Record<string, string> = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-6'
  };
  const isClickable = !!onClick;
  return <div className={`bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl ${paddings[padding]} ${isClickable ? 'cursor-pointer hover:border-[#C8A84E]/30 transition-colors duration-200' : ''} ${className}`} onClick={onClick} role={isClickable ? 'button' : undefined} tabIndex={isClickable ? 0 : undefined} onKeyDown={isClickable ? e => {
    if (e.key === 'Enter' || e.key === ' ') onClick();
  } : undefined} data-id="element-572">
      {title && <div className="flex items-center justify-between mb-4" data-id="element-573">
          <h3 className="text-lg font-semibold text-white" data-id="element-574">{title}</h3>
          {titleRight}
        </div>}
      {children}
    </div>;
}